import { View, ScrollView } from "react-native";
import { useRouter } from "expo-router";
import { Text } from "./components/Text";
import Header from "./components/PickupDriveThru/Header";
import FooterButton from "./components/PickupDriveThru/FooterButton";
import { useTranslateText } from "./utils";
import { usePickupDriveThruVerifiedStyles } from "./components/PickupDriveThru/styles";

export default function PickupDriveThruVerified() {
  const router = useRouter();
  const { t } = useTranslateText();
  const styles = usePickupDriveThruVerifiedStyles();

  return (
    <View style={styles.container} testID="pickupDriveThruVerifiedContainer">
      <Header showBackButton={false} />
      <ScrollView style={styles.scroll} contentContainerStyle={styles.content}>
        <Text style={styles.title}>
          {t("tpos.pickupDriveThru.orderVerified")}
        </Text>
        <Text style={styles.message}>
          {t("tpos.pickupDriveThru.orderVerifiedMessage")}
        </Text>
        <View testID="orderVerifiedIcon" style={styles.checkCircle}>
          <Text style={styles.checkMark}>✓</Text>
        </View>
      </ScrollView>
      <FooterButton
        testID="mainMenuButton"
        text={t("tpos.pickupDriveThru.mainMenu")}
        // The entry screen was replaced by this one, so back returns home
        onPress={() => router.back()}
      />
    </View>
  );
}
